export default __webpack_public_path__ + "static/media/287.fd0b783f.jpg";